module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#fafafa",
      "margin": "0",
      "padding": "0.5em",
      "padding-left": "1em",
      "padding-top": "2.51em",
      "border-bottom": "none",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2",
    staticStyle: {
      "min-width": "60%",
      "max-width": "65%"
    }
  }, [(_vm.can_show_back_nav) ? _c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })]) : _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "background-color": "#6200ff",
      "border-radius": "50%",
      "padding": "0.41em"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#ffffff"
    }
  }, [_vm._v("M")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "18px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "38px",
      "margin-top": "-1.52em",
      "padding-top": "0",
      "display": "block"
    },
    attrs: {
      "id": "appName"
    }
  }, [(_vm.headerdata.name && (_vm.headerdata.name != '')) ? _c('span', [_vm._v(_vm._s(_vm.headerdata.name))]) : _c('span', {
    staticStyle: {
      "font": "0.92em agency-fb",
      "font-weight": "800"
    }
  }, [_vm._v(_vm._s(_vm.app_name))])])])]), _vm._v(" "), (_vm.can_show_side_nav) ? _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.loggedIn) ? _c('span', {
    staticStyle: {
      "margin-top": "-0.2em",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your orders")])]) : _c('p', [_vm._m(0)])]), _vm._v(" "), (_vm.can_show_back_nav) ? _c('li', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('component-account-menu')], 1) : _c('div', [_vm._m(1), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/create/account/business"
    }
  }, [_vm._v("Your Account"), _c('br'), _vm._v("Login | Create account")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd93932e"}!./src/pages/MainHeader/template.html
// module id = 580
// module chunks = 0